function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#clip0_3088_51212)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.85 4.57h-1.63c-1.06 0-1.8-.73-1.8-1.8V1.16H5.23c-.45 0-.66.21-.66.67v3.3c0 .42-.4.7-.77.56-.23-.1-.37-.27-.37-.52 0-1.18-.02-2.36 0-3.54C3.45.75 4.2.02 5.08.01c.62-.02 1.25 0 1.87 0L11.88 0a.8.8 0 01.61.26 601.9 601.9 0 003.26 3.26.8.8 0 01.25.6v10.05c0 1.1-.73 1.83-1.84 1.83h-4.4c-.45 0-.74-.4-.58-.79.1-.23.3-.35.59-.35h4.39c.1 0 .22 0 .31-.04.23-.08.35-.25.38-.48v-.16-9.61zm-2.28-2.56v.94c.02.24.24.45.48.47.31.02.63 0 .94 0l-1.42-1.41z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.56 16a4.57 4.57 0 11.03-9.14A4.57 4.57 0 014.56 16zM8 11.44a3.43 3.43 0 10-6.87-.01 3.43 3.43 0 006.87.01zM8 4.57H6.34c-.38 0-.64-.23-.64-.57 0-.34.26-.57.64-.57h3.3c.37 0 .63.23.63.56 0 .34-.25.58-.63.58H8zM11.42 7.43H9.77c-.37 0-.63-.24-.63-.57 0-.34.26-.57.64-.57h3.28c.39 0 .64.23.65.56 0 .35-.26.58-.65.58h-1.64zM11.99 10.29h-1.1c-.35 0-.61-.25-.6-.58 0-.33.25-.56.61-.57h2.18c.37 0 .62.24.63.57 0 .34-.26.58-.64.58H12zM12 12h1.1c.35 0 .61.24.6.58 0 .32-.25.56-.6.56H10.9c-.35 0-.6-.24-.6-.56-.01-.34.25-.58.6-.58H12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 13.15c-.32-.02-.5-.13-.6-.35a.53.53 0 01.1-.61l.48-.48L5.3 9.89a.56.56 0 01.66-.12c.21.1.36.33.32.57a.71.71 0 01-.17.36c-.75.76-1.51 1.52-2.28 2.27-.1.1-.25.14-.32.18zM4 10.28c0 .3-.25.57-.56.58a.58.58 0 01-.58-.56c-.01-.32.24-.58.56-.58.31 0 .57.25.58.56zM5.7 12c.32 0 .58.25.58.56 0 .32-.25.58-.57.58a.58.58 0 01-.57-.57c0-.3.25-.57.57-.57z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3088_51212"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgTaxAccounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxAccounting);
export default __webpack_public_path__ + "static/media/tax-accounting.d3109b87.svg";
export { ForwardRef as ReactComponent };